// import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
// import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import MessageIcon from '@mui/icons-material/Message';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { cloneDeep, get, isArray, set } from 'lodash';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import TreeNavigationButtons from '../../../components/ui-component/form-component/tree-view-navigation/TreeNavigationButtons';
import TreeNavigationView from '../../../components/ui-component/form-component/tree-view-navigation/TreeNavigationView';
import { constructHierarchyArray, extractIds } from '../../../components/ui-component/form-component/tree-view-navigation/TreeNavigatrionHelper';
import LoadingBackdrop from '../../../components/ui-component/loading/LoadingBackdrop';
import MuiDialog from '../../../components/ui-component/mui-dialog/MuiDialog';
import MuiSnackbar from '../../../components/ui-component/mui-snackbar/MuiSnackbar';
import NoDetailsInfo from '../../../components/ui-component/no-details-info/NoDetailsInfo';
import ApplicationContextProvider from '../../../context/ApplicationContext';
import GetRecord from '../../../lib/api/GetRecord';
import GetRecords from '../../../lib/api/GetRecords';
import Population from '../../../lib/api/Populations.json';
import { PostRecord } from '../../../lib/api/PostRecord';
import { PushNotificationApplication } from '../../../lib/api/PushNotification';
import PutRecord from '../../../lib/api/PutRecord';
import { APIS } from '../../../lib/constants/apis';
import { ANTRAG_TYP, ANTRAGS_STATUS, APP_STATUS_EDITABLE, APP_STATUS_EDITABLE_VN, VN_STATUS } from '../../../lib/constants/constant';
import { PAGES_URLS } from '../../../lib/constants/routes';
import { ErrorValidation, TreeNodeType } from '../../../lib/types/types';
import { GetFieldErrors } from '../../../lib/validation/ApplicationValidator';
import { checkErrorInCurrentNode, setHasBeenVisited, setShowError, validateAll } from '../../../lib/validation/validationHelperFunction';
import { getFieldNamefromDataPath, isObjectEmpty, removeDataKeys, removeNullDeep } from '../../../utils/helper';
import AntragRightSideBar from './AntragRightSideBar';
import ApplicationBreadcrumbs from './application-breadcrumbs/ApplicationBreadCrumbs';
import { executeAntragsFormulas } from './formulas/foerderantrag/foerderantragFormulas';
import { executeVerwendungsnachweisFormulas } from './formulas/verwendungsnachweis/VerwendungsnachweisFormulas';
import { FoerderAntragDependencies } from './structure/foerderantrag/FoerderAntragDependencies';
import { FoerderAntragStruktur } from './structure/foerderantrag/FoerderAntragStructure';
import { VerwendungsnachweisDependencies } from './structure/verwendungsnachweis/VerwendungsnachweisDependencies';
import { VerwendungsnachweisStructure } from './structure/verwendungsnachweis/VerwendungsnachweisStructure';
import AntragZusatzInfo from './zusatz-info/AntragZusatzInformation';
import OnlineAntragRightSideBarBottomIcons from './OnlineAntragRightSideBarBottomIcons';

// import Schemas
import Schema from '../../../lib/paths/antrag_FULL_Paths.json';
import VerwendungsnachweisSchema from '../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
import SparteSchema from '../../../lib/paths/division_FULL_Paths.json';
import { isEqual } from 'lodash';
import { find } from 'lodash';
import { saveOnlyChanges } from './SaveOnlyChanges';
const SP_P = SparteSchema.attributes;
let P = Schema.attributes;
const VN_P = VerwendungsnachweisSchema.attributes;

export default function OnlineAntrag() {
	const navigate = useNavigate();
	const [printMode, setPrintMode] = useState(false);
	// const [rightSidebarOpen, setRightSidebarOpen] = useState(true);


	const [hasUnsavedAttributes, setHasUnsavedAttributes] = useState(false);
	const [treeStructure, setTreeStructure] = useState<TreeNodeType[]>([]);
	const [currentNode, setCurrentNode] = useState<string[]>(['1']);
	const [wsActive, setWsActive] = useState<boolean>(false);
	const [wsError, setWsError] = useState<boolean>(false);
	const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState<boolean>(false);
	const [appSubmitSuccess, setAppSubmitSuccess] = useState<boolean | null>(false);
	const [errors, setErrors] = useState<ErrorValidation[]>([]);
	const [storageHasBeenVisited, setStorageHasBeenVisited] = useState<boolean>(false);
	const [canSubmitZuwendungsvertrag, setCanSubmitZuwendungsvertrag] = useState<boolean>(false);
	const [canSubmitPruefmitteilung, setCanSubmitPruefmitteilung] = useState<boolean>(false);
	const [skipValidation, setSkipValidation] = useState<boolean>(false);


	const location = useLocation();
	const containerRef = useRef(null);


	const numericId = get(location, 'state.id', 0);

	const [application, setApplication] = useState({}); //Antrag, wie er original in strapi liegt
	const [updates, setUpdates] = useState({}); //hier werden alle Usereingaben reingeschrieben. Wird für PUT verwendet
	const [allFoerderProgramm, setAllFoerderProgramm] = useState([]);
	const [schulJahrDetails, setSchulJahrDetails] = useState({});
	const [allSparte, setAllSparte] = useState([]);

	const readOnly = useMemo(() => {
		return GetReadOnly(get(location, 'state.api'), application);
	}, [application, location]);
	const IconRight = MessageIcon;

	const antragType = getAntragTypeText(application, location);
	const antragStatus = get(application, P.Status_Status.path, '');

	const handleNavigation = (nodeIds: string[], buttonClick?: string) => {
		let hasErrorInCurrentNode = hasCurrentContentError();
		if (buttonClick === 'next' || buttonClick === 'previous') {
			const allNodesIdsArr = extractIds(treeStructure);
			const currentNodeStr = currentNode[currentNode.length - 1];
			const currentNodeIndex = allNodesIdsArr.findIndex((ele: any) => ele === currentNodeStr);

			if (currentNodeIndex !== -1) {
				const prevNodeStr = allNodesIdsArr[currentNodeIndex - 1];
				const nextNodeStr = allNodesIdsArr[currentNodeIndex + 1];

				if (buttonClick === 'next') {
					setCurrentNode(constructHierarchyArray(nextNodeStr));
					if (hasErrorInCurrentNode) {
						return;
					}
					else {
						saveApplication();
					}
				}
				if (buttonClick === 'previous') {
					setCurrentNode(constructHierarchyArray(prevNodeStr));
					if (hasErrorInCurrentNode) {
						return;
					}
					else {
						saveApplication();
					}
				}
			}
		}
		if (Array.isArray(nodeIds) && nodeIds.length) {
			saveApplication();
			setCurrentNode(constructHierarchyArray(nodeIds[0], treeStructure));
		}
		const treeStruc = validateAll(updates, treeStructure, setErrors, skipValidation, true);
		setTreeStructure(treeStruc);
	};

	const handlePrint = () => {
    // Force a re-render with fresh data before printing
    setPrintMode(true);
    
    // Use a callback ref to ensure data is rendered before printing
    requestAnimationFrame(() => {
        setTimeout(() => {
            // Flush all pending state updates
            if (containerRef.current) {
                const onAfterPrint = () => {
                    setPrintMode(false);
                    window.removeEventListener('afterprint', onAfterPrint);
                };
                window.addEventListener('afterprint', onAfterPrint);

                const style = document.createElement('style');
                style.textContent = `
                    @page {
                        size: landscape;
                    }
                    @media print {
                        body { margin: 0; padding: 0; }
                    }
                `;
                document.head.appendChild(style);

                // Ensure all children are mounted and rendered
                window.print();

                document.head.removeChild(style);
            }
        }, 3500);  // Added delay to allow data to be fully rendered before print dialog opens
    });
};

	const setApplicationProperty = (key: string, value: any) => {
		let appCopy = cloneDeep(updates);
		set(appCopy, key, value);

		const formulaFields = executeFormulas(appCopy, get(location, 'state.api'), allFoerderProgramm, schulJahrDetails, allSparte);
		if (isArray(formulaFields) && formulaFields.length > 0) {
			for (let ele of formulaFields) {
				set(appCopy, get(ele, 'path'), get(ele, 'value'));
			}
		}
		setHasUnsavedAttributes(true);
		setUpdates(appCopy);
	};

	const saveApplication = async (submit: boolean = false, newApplication: boolean | any = false, changeLastEdited: boolean = true) => {
		if (!hasUnsavedAttributes && newApplication === false && !submit) return;
		let updateRecord = newApplication || cloneDeep(updates);
		const saveAll = true;
		const api = get(location, 'state.api');

		if (submit) {
			if (get(location, 'state.api') === APIS.Antrag) {
				if (get(updateRecord, P.Status_Status.path) === ANTRAGS_STATUS.vertragUebermittel) {
					set(updateRecord, P.Status_Status.path, ANTRAGS_STATUS.ZuwendungsvertragUnterzeichnet);
					set(updateRecord, P.Zuwendungsvertarg_Unterschrieben_Am.path, new Date());
				} else {
					set(updateRecord, P.Zusammenfassung_Ueberblick_Eingereicht_Am.path, new Date());
					set(updateRecord, P.Status_Status.path, ANTRAGS_STATUS.inPruefung);
				}
			}
			if (get(location, 'state.api') === APIS.Verwendungsnachweis) {
				if (get(updateRecord, VN_P.Status_Status.path) === VN_STATUS.PruefmitteilungUebermittelt) {
					set(updateRecord, VN_P.Status_Status.path, VN_STATUS.PruefmitteilungUebermittelt);
					// set(updateRecord, VN_P....am.path, new Date());
				} else {
					set(updateRecord, VN_P.Status_Status.path, ANTRAGS_STATUS.inPruefung);
					set(updateRecord, VN_P.Allgemein_Eingereicht_Am.path, new Date());
				}
			}
		}

		if (changeLastEdited) {
			if (get(location, 'state.api') === APIS.Antrag) {
				set(updateRecord, P.itaros_last_update.path, new Date());
			}
			if (get(location, 'state.api') === APIS.Verwendungsnachweis) {
				set(updateRecord, VN_P.Allgemein_Geaendert_Durch_Antragsteller.path, new Date());
			}
		}
		try {
			setWsActive(true);

			let updateRecordCopy = cloneDeep(updateRecord);
			const formulaFields = executeFormulas(updateRecordCopy, get(location, 'state.api'), allFoerderProgramm, schulJahrDetails, allSparte);
			if (isArray(formulaFields) && formulaFields.length > 0) {
				for (let ele of formulaFields) {
					set(updateRecordCopy, get(ele, 'path'), get(ele, 'value'));
				}
			}

			let res = false;
			let updatedRecord;
			if (saveAll) {
				if (api === APIS.Kostenposition) {
					// save Nachweisposition (globale Belegliste) zugeordnet zum Antrag, noch ohne Zuordnung zu VN
					let nachweispositions = get(updateRecord, P.Antrag_Kostenpositions.path, []);
					for (let i = 0; i < nachweispositions.length; i++) {
						await updateOrInsertRelation(updateRecord, application, P.Antrag_Kostenpositions.path + '.' + i, P.Antrag_Kostenpositions.path, api);
					}
					res = await GetRecord(APIS.Antrag, numericId, Population.antrag.BELEGLISTE);
				}
				else {
					updatedRecord = await updateRelations(updateRecord, application, api);
					res = await PutRecord(
						get(location, 'state.api'),
						get(updatedRecord, 'id'),
						{ data: get(updatedRecord, 'attributes') },
						get(Population, `${get(location, 'state.api').replace(/.$/, '')}.${get(location, 'state.antragsformular', 'FULL')}`)
					);
				}

			} else {
				const saved =
					(await saveOnlyChanges(
						application,
						updateRecord,
						Schema,
						get(location, 'state.api'),
						get(Population, `${get(location, 'state.api').replace(/.$/, '')}.FULL`)
					)) || [];

				res = saved[0];
				updatedRecord = saved[1];
			}
			if (res) {
				setApplication(removeNullDeep(removeDataKeys(get(res, 'data', []))));
				setUpdates(removeNullDeep(removeDataKeys(get(res, 'data', []))));

				if (submit) {
					await PushNotificationApplication(get(location, 'state.api'), updatedRecord);
					setAppSubmitSuccess(true);
				} else setOpenSuccessSnackbar(true);
			}
		} catch (err: any) {
			const errorData = JSON.parse(get(err, 'message', {}));
			if (get(errorData, 'error.status') === 403 || get(errorData, 'error.status') === 401) {
				localStorage.removeItem('vdmk-token');
				window.location.reload();
			}
			console.error('ERROR: Updating Application ', err);
			setWsError(true);
		} finally {
			setHasUnsavedAttributes(false);
			setWsActive(false);
		}
	};

	const findNodeContent = (nodes: TreeNodeType[], nodeId: any[]): JSX.Element | null => {
		if (printMode) {
			let result: any = [];
			for (const node of nodes) {
				if (node.content) result.push(
					<Box key={node.label} sx={{ pageBreakInside: 'avoid' }}>
						{node.content}
					</Box>
				);
				if (node.children) {
					node.children.map((el) => {
						result.push(
							<Box key={el.label} sx={{ pt: 1, pageBreakInside: 'avoid' }}>
								<Typography>{el.label}</Typography>
								{el.content}
							</Box>
						);
					});
				}
			}
			return result;
		} else {
			for (const node of nodes) {
				if (node.children) {
					const foundContent = findNodeContent(node.children, nodeId);

					if (foundContent) {
						return (
							<>
								{node.content}
								<Tabs
									value={nodeId[1]}
									variant='scrollable'
									scrollButtons='auto'
									aria-label='scrollable auto tabs example'
									onChange={(_e, newId) => {
										handleNavigation([newId]);
									}}
								>
									{node.children.map((ele, i) => {
										return (
											<Tab
												key={i}
												value={ele.id}
												label={ele.label}
												icon={ele.hasComment ? <IconRight sx={{ color: 'primary.main' }} /> : <></>}
												iconPosition='end'
												sx={{ color: ele.showError ? 'error.main' : null }}
											/>
										);
									})}
								</Tabs>
								{foundContent}
							</>
						);
					}
				}
				if (node.id === nodeId[nodeId.length - 1]) {
					return node.content;
				}
			}
			return null;
		}
	};

	function hasCurrentContentError(): boolean {
		if (treeStructure.length <= 0) return false;

		const antragId = get(application, 'id');
		// get current content and compare path with errorList
		const errorList = GetFieldErrors(treeStructure, updates, skipValidation);
		setErrors(errorList);
		const curNode = currentNode[currentNode.length - 1];
		const parentNode = currentNode[0];
		let hasErrorParent = checkErrorInCurrentNode(treeStructure, errorList, parentNode);
		let structure = [...treeStructure];
		let hasErrorChild;
		if (Number(curNode) > 0) {
			// check if current node is child node
			if (parentNode !== curNode) {
				hasErrorChild = checkErrorInCurrentNode(treeStructure, errorList, curNode);
				setShowError(treeStructure, currentNode, hasErrorParent, hasErrorChild);
			} else {
				setShowError(treeStructure, currentNode, hasErrorParent);
			}
			setHasBeenVisited(structure, currentNode);
			setTreeStructure(structure);
		}
		if (!storageHasBeenVisited) {
			localStorage.setItem(antragId, JSON.stringify(true));
			setStorageHasBeenVisited(true);
		}
		// console.log({ errorList });
		return hasErrorChild === undefined ? hasErrorParent : hasErrorChild;
	}

	const validateCompleteForm = () => {
		let structure = validateAll(application, treeStructure, setErrors, skipValidation);
		setTreeStructure(structure);
	};

	const renderContent = () => {
		if (!currentNode) {
			return null;
		}
		return findNodeContent(treeStructure, currentNode);
	};

	useEffect(() => {
		const updatedTreeStructure = GetTreeStructure(
			get(location, 'state.api'),
			updates,
			treeStructure,
			skipValidation,
			storageHasBeenVisited,
			setStorageHasBeenVisited,
			setErrors,
			allFoerderProgramm,
			printMode
		);

		// Setting current node to the first tab in the first node of tree if the first node has children.
		if (currentNode.includes('1') && updatedTreeStructure[0]?.children) {
			setCurrentNode(['1', '1.1']);
		}

		if (get(application, P.Status_Status.path) === ANTRAGS_STATUS.vertragUebermittel) {
			setCanSubmitZuwendungsvertrag(true);
			setSkipValidation(!canSubmitZuwendungsvertrag);
		}
		if (get(application, VN_P.Status_Status.path) === VN_STATUS.PruefmitteilungUebermittelt) {
			setCanSubmitPruefmitteilung(true);
			setSkipValidation(!canSubmitPruefmitteilung);
		}

		setTreeStructure(updatedTreeStructure);
		// hasCurrentContentError();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [application, location, updates]);

	useEffect(() => {
		const fetchApp = async () => {
			setWsActive(true);
			try {
				let appRes = await GetRecord(
					get(location, 'state.api'),
					numericId,
					get(Population, `${get(location, 'state.api').replace(/.$/, '')}.${get(location, 'state.antragsformular', 'FULL')}`)
				);
				const app = removeNullDeep(removeDataKeys(get(appRes, 'data', [])));

				const programmRes = await GetRecords(APIS.FörderProgramme);
				const schulJahrRes = await GetRecords(APIS.SchulJahr, Population.schluljahr.FULL);
				const activeSchulJahr = getActiveSchuljahr(schulJahrRes);
				let sparteRes = await GetRecords(APIS.Sparte, [getFieldNamefromDataPath(SP_P.Foerderprogramm.path)]);

				setApplication(app);
				setUpdates(app);

				setAllFoerderProgramm(removeDataKeys(removeNullDeep(get(programmRes, 'data', []))));
				// setSchulJahrDetails(removeDataKeys(removeNullDeep(get(schulJahrRes, 'data', [])[0])));
				setSchulJahrDetails(activeSchulJahr);


				if (sparteRes) setAllSparte(removeDataKeys(removeNullDeep(get(sparteRes, 'data', []))));

			} catch (err: any) {
				console.error('ERROR: Fetch App', err);
			} finally {
				setWsActive(false);
			}
		};
		if (numericId) fetchApp();
	}, [location, numericId]);

	const DialogContent = useMemo(() => {
		switch (get(location, 'state.api')) {
			case APIS.Antrag:
				if (get(updates, P.Status_Status.path) === ANTRAGS_STATUS.vertragUebermittel)
					return 'Ihr unterschriebener Vertrag wurde erfolgreich übermittelt.';
				return 'Ihr Antrag wurde erfolgreich eingereicht';
			case APIS.Verwendungsnachweis:
				if (get(application, VN_P.Allgemein_Nachweistyp.path) === ANTRAG_TYP.Zwischenmeldung) return 'Ihr Zwischenmeldung wurde erfolgreich eingereicht einreichen';
				return 'Ihr Verwendungsnachweis wurde erfolgreich eingereicht';
			default:
				return 'Ihr Antrag wurde erfolgreich eingereicht';
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!numericId) return <NoDetailsInfo title='Antrag' goBackUrl={PAGES_URLS.MeineFoerderung} />;
	return (
		<>
			<LoadingBackdrop open={wsActive} />
			<Box sx={{ paddingLeft: '1.5rem', paddingRight: '1.5rem' }}>
				<ApplicationContextProvider
					application={updates}
					schulJahrDetails={schulJahrDetails}
					setApplicationProperty={setApplicationProperty}
					saveApplication={saveApplication}
					handlePrint={handlePrint}
					tree={treeStructure}
					errors={errors}
					printMode={printMode}
					readOnly={readOnly}
				>
					<MuiDialog
						open={appSubmitSuccess}
						onClose={() => {
							setAppSubmitSuccess(false);
							navigate(PAGES_URLS.MeineFoerderung);
						}}
						onCloseButtonName='Zurück zu meinen Anträgen'
						title={'Erfolg'}
						content={DialogContent}
					/>
					<MuiSnackbar showSnackbar={openSuccessSnackbar} closeSnackbar={() => setOpenSuccessSnackbar(false)} alertMessage='Antrag gesichert' />
					<MuiSnackbar showSnackbar={wsError} error={true} closeSnackbar={() => setWsError(false)} alertMessage='Etwas ist schief gelaufen' />
					{/* <Box className={`right-sidebar-toggle ${rightSidebarOpen ? 'open' : 'closed'}`} sx={{ display: { xs: 'none', md: 'none', lg: 'block' } }}>
						{rightSidebarOpen && (
							<IconButton aria-label='Seitenleiste umschalten' className='right-sidebar-toggler' onClick={() => setRightSidebarOpen(false)}>
								<ChevronRightOutlinedIcon />
							</IconButton>
						)}
						{!rightSidebarOpen && (
							<IconButton aria-label='Seitenleiste umschalten' className='right-sidebar-toggler' onClick={() => setRightSidebarOpen(true)}>
								<ChevronLeftOutlinedIcon />
							</IconButton>
						)}
					</Box> */}
					<Grid container columns={12} spacing={6} sx={{ mt: '1rem', padding: '0 1rem', minHeight: '80vh' }}>
						{!printMode && (
							<Grid sm={0} md={2}>
								<TreeNavigationView
									treeStructure={treeStructure}
									currentNode={currentNode}
									handleNavigation={handleNavigation}
									antragType={antragType}
									antragStatus={antragStatus}
								/>
							</Grid>
						)}
						<Grid sm={12} md={8} sx={{ display: 'flex', flexDirection: 'column' }}>
							{!printMode && (<ApplicationBreadcrumbs api={get(location, 'state.api')} />)}
							<AntragZusatzInfo api={get(location, 'state.api')} />
							{/* {renderContent()}
							 */}
							<div id='print-root' ref={containerRef}>
								{renderContent()}
							</div>
							<TreeNavigationButtons
								treeStructure={treeStructure}
								currentNode={currentNode}
								handleNavigation={handleNavigation}
								hasCurrentContentError={hasCurrentContentError}
								validateCompleteForm={validateCompleteForm}
							/>
						</Grid>
						<Grid id='section-right-sidebar' xs={0} sm={0} md={2}>
							<AntragRightSideBar api={get(location, 'state.api')} />
							<OnlineAntragRightSideBarBottomIcons api={get(location, 'state.api')} />
						</Grid>
					</Grid>
				</ApplicationContextProvider>
			</Box>
		</>
	);
}
const GetReadOnly = (api: string, application: any) => {
	switch (api) {
		case APIS.Antrag:
			return !APP_STATUS_EDITABLE.includes(get(application, P.Status_Status.path));

		case APIS.Verwendungsnachweis:
			return !APP_STATUS_EDITABLE_VN.includes(get(application, VN_P.Status_Status.path));
		default:
			return true;
	}
};

const GetTreeStructure = (
	api: string,
	application: any,
	treeStructure: TreeNodeType[],
	readOnly: boolean,
	storageHasBeenVisited: boolean,
	setStorageHasBeenVisited: any,
	setErrors: any,
	allFoerderProgramms?: any,
	printMode: boolean = false
): TreeNodeType[] => {
	switch (api) {
		case APIS.Verwendungsnachweis:
			return getMappedTreeStructure(
				application,
				VerwendungsnachweisStructure(application, allFoerderProgramms, readOnly),
				treeStructure,
				storageHasBeenVisited,
				setStorageHasBeenVisited,
				setErrors,
				readOnly
			);
		default:
			return getMappedTreeStructure(
				application,
				FoerderAntragStruktur(application, printMode),
				treeStructure,
				storageHasBeenVisited,
				setStorageHasBeenVisited,
				setErrors,
				readOnly
			);
	}
};

const updateRelations = async (updates: any, originApplication: any, api: string) => {
	let appCopy = cloneDeep(updates);
	let updateDependencies = GetUpdateDependencies(appCopy, api);

	// POST or PUT for the relation
	for (let relation of get(updateDependencies, 'relations', [])) {
		let path = get(relation, 'field');
		let value = get(appCopy, path, []);
		let api = get(relation, 'api');
		if (isArray(value)) {
			for (let index in value) {
				await updateOrInsertRelation(appCopy, originApplication, path + '.' + index, path, api);
			}
		} else {
			await updateOrInsertRelation(appCopy, originApplication, path, path, api);
		}
		// unset(application, path);
	}
	return appCopy;
};

const updateOrInsertRelation = async (updates: any, originApplication: any, path: string, pathWithoutIndex: string, api: string) => {
	let data = { data: get(updates, path + '.attributes', {}) };
	if (isObjectEmpty(get(data, 'data', ''))) return;

	let id = get(updates, path + '.id');
	if (id) {
		// check: has the relation changed?
		const originalNodes = get(originApplication, pathWithoutIndex);
		const originNode = find(originalNodes, { id: id });
		let originData = { data: get(originNode, 'attributes', {}) };
		const equal = isEqual(originData, data);
		if (!equal) await PutRecord(api, id, data);
	} else {
		let res = await PostRecord(api, data);
		//set(application, path, get(res, 'data.id', null));
		set(updates, path, removeNullDeep(removeDataKeys(get(res, 'data', []))));
	}
};

export const GetUpdateDependencies = (application: any, api: string) => {
	switch (api) {
		case APIS.Antrag:
			return FoerderAntragDependencies(application);
		case APIS.Verwendungsnachweis:
			return VerwendungsnachweisDependencies();
	}
};

const executeFormulas = (application: any, api: string, allFoerderProgramm: any, schulJahrDetails: any, allSparte: any): any => {
	if (api === APIS.Antrag) {
		return executeAntragsFormulas(application, allFoerderProgramm, schulJahrDetails, allSparte);
	}
	if (api === APIS.Verwendungsnachweis) {
		return executeVerwendungsnachweisFormulas(application, allFoerderProgramm);
	}
};

const mapAndGetTreeErrorNavigation = (initialTree: TreeNodeType[], treeStructure: TreeNodeType[]) => {
	let currentTree = [...treeStructure];
	const updatedTree = replaceFormStruc(currentTree, initialTree);
	return updatedTree;
};

const getMappedTreeStructure = (
	application: any,
	initialTree: TreeNodeType[],
	treeStructure: TreeNodeType[],
	storageHasBeenVisited: boolean,
	setStorageHasBeenVisited: any,
	setErrors: any,
	readOnly: boolean
): TreeNodeType[] => {
	const initial = treeStructure.length <= 0 && get(application, 'attributes');

	if (initial) {
		const antragId = get(application, 'id');
		const formHasBeenVisited = localStorage.getItem(antragId) ? localStorage.getItem(antragId) : false;
		if (formHasBeenVisited && !storageHasBeenVisited) {
			setStorageHasBeenVisited(true);
			return validateAll(application, initialTree, setErrors, readOnly);
		}
		return initialTree;
	} else if (treeStructure.length > 0 && get(application, 'attributes')) {
		const antragId = get(application, 'id');
		const formHasBeenVisited = localStorage.getItem(antragId) ? localStorage.getItem(antragId) : false;
		if (formHasBeenVisited && !storageHasBeenVisited) {
			setStorageHasBeenVisited(true);
			return validateAll(application, treeStructure, setErrors, readOnly);
		} else {
			return mapAndGetTreeErrorNavigation(initialTree, treeStructure);
		}
	}
	return [];
};

const replaceFormStruc = (oldTree: TreeNodeType[], initialTree: TreeNodeType[]) => {
	return initialTree.map((item: TreeNodeType) => {
		const result = findNodeByLabel(oldTree, item.label);
		const node = result ? result : item;
		let formStruc;
		let children;
		if (item.formStruc) {
			formStruc = {
				formStruc: item.formStruc,
			};
		}
		if (item.children) {
			children = {
				children: item.children.map((child) => {
					const resultChild = findNodeByLabel(oldTree, item.label, child.label);
					const nodeChild = resultChild ? resultChild : child;

					return {
						...child,
						showError: nodeChild.showError,
						hasBeenVisited: nodeChild.hasBeenVisited,
						formStruc: child.formStruc,
					};
				}),
			};
		}
		return {
			...item,
			showError: node.showError,
			hasBeenVisited: node.hasBeenVisited,
			...formStruc,
			...children,
		};
	});
};

const findNodeById = (tree: TreeNodeType[], id: string): TreeNodeType | null => {
	for (const node of tree) {
		if (node.id === id) {
			return node;
		}

		if (node.children) {
			const foundInChildren = findNodeById(node.children, id);
			if (foundInChildren) {
				return foundInChildren;
			}
		}
	}
	return null;
};
const findNodeByLabel = (tree: TreeNodeType[], parentLabel: string, childLabel?: string): TreeNodeType | null => {
	for (const node of tree) {
		if (!childLabel && node.label === parentLabel) return node;

		if (childLabel === node.label) return node;

		if (childLabel && node.children && node.label === parentLabel) {
			const foundInChildren = findNodeByLabel(node.children, parentLabel, childLabel);
			if (foundInChildren) {
				return foundInChildren;
			}
		}
	}
	return null;
};

function getAntragTypeText(application: any = {}, location: any): string {
	switch (get(location, 'state.api')) {
		case APIS.Antrag:
			return 'Antrag';
		case APIS.Verwendungsnachweis:
			if (get(application, VN_P.Allgemein_Nachweistyp.path) === ANTRAG_TYP.Zwischenmeldung)
				return 'Zwischenmeldung';
			return 'Verwendungsnachweis';
		default:
			return '';
	}
}

function getActiveSchuljahr(schulJahrRes: any) {
	if (get(schulJahrRes, 'data', []).length > 0) {
		const allschulJahre = removeNullDeep(removeDataKeys(get(schulJahrRes, 'data', [])));
		const activeSchuljahre = allschulJahre.filter((item: any) => {
			const attrs = item.attributes || {};
			return attrs.erste_Halbjahr?.Aktiv === true || attrs.zweite_Halbjahr?.Aktiv === true;
		});
		return activeSchuljahre[0];
	} else {
		return null;
	}
}